"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var api_wrapper_1 = require("../../api/api-wrapper");
var manychat_api_1 = require("../../api/manychat.api");
var sendcloud_welcomebox_1 = require("../../api/sendcloud-welcomebox");
var customer_preview_const_1 = require("../../const/customer-preview.const");
var element_generator_1 = require("../../element-generator");
var error_handling_1 = require("../../error-handling");
var helper_1 = require("../../helper");
var object_service_1 = require("../../object-service");
var translation_1 = __importDefault(require("../../translation"));
var variables_const_1 = require("../../variables.const");
var payment_const_1 = require("./const/payment.const");
var event_listeners_1 = require("./event-listeners");
var form_const_1 = require("./form.const");
var price_preview_1 = require("./price-preview");
var send_email_service_1 = require("./services/send-email.service");
var Form = /** @class */ (function () {
    function Form() {
        this.errorHandling = object_service_1.ObjectService.getInstance(error_handling_1.ErrorHandling);
        this.apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
        this.helper = object_service_1.ObjectService.getInstance(helper_1.Helper);
        this.priceOverview = object_service_1.ObjectService.getInstance(price_preview_1.PricePreview);
        this.elementGenerator = object_service_1.ObjectService.getInstance(element_generator_1.ElementGenerator);
        this.sendEmailService = object_service_1.ObjectService.getInstance(send_email_service_1.SendEmailService);
        this.eventListeners = object_service_1.ObjectService.getInstance(event_listeners_1.EventListeners);
        this.formInvalid = true;
        this.newContract = {};
        this.newCustomer = {
            countryCode: localStorage.getItem('countryCode') || (variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.countryCode) || 'DE',
            paymentChoice: 'DIRECT_DEBIT',
        };
        this.createCustomerLoading = false;
    }
    Form.prototype.getDataFromInputs = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        this.formInvalid = false;
        var freeModules = [], paidModules = [];
        if (localStorage.getItem('selectableModules')) {
            freeModules = JSON.parse(localStorage.getItem('selectableModules')).map(function (a) { return ({
                id: a,
            }); });
        }
        if (localStorage.getItem('optionalModules')) {
            paidModules = JSON.parse(localStorage.getItem('optionalModules')).map(function (a) { return ({
                id: a,
            }); });
        }
        this.newContract = {
            rateBundleTermId: +this.helper.getPersistedData(form_const_1.MAPPINGS.membershipId),
            startDate: (_b = (_a = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.startDate) !== null && _a !== void 0 ? _a : localStorage.getItem('startDate')) !== null && _b !== void 0 ? _b : this.helper.getTodaysDate(),
            preuseDate: (_d = (_c = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.preuseDate) !== null && _c !== void 0 ? _c : localStorage.getItem('preuseDate')) !== null && _d !== void 0 ? _d : this.helper.getTodaysDate(),
            selectedRateBundleModules: freeModules,
            optionalRateBundleTermModules: paidModules,
        };
        var userAge = this.determineBirthDate();
        console.log('Birthday', userAge.age, userAge.date, variables_const_1._matured, variables_const_1._minimumAge);
        if ((_e = userAge === null || userAge === void 0 ? void 0 : userAge.date) === null || _e === void 0 ? void 0 : _e.length) {
            this.guardianValidation(userAge.age);
            if (userAge.age < variables_const_1._matured) {
                if (userAge.age >= variables_const_1._minimumAge) {
                    var guardianName = this.helper.get$Val(form_const_1.MAPPINGS.guardian);
                    if (guardianName === null || guardianName === void 0 ? void 0 : guardianName.length) {
                        this.newContract.notes =
                            translation_1.default.t('legalRepresentativeName') + ': ' + guardianName;
                        this.removeErrorFromFormField(form_const_1.MAPPINGS.guardian);
                        this.removeErrorFromFormField(form_const_1.MAPPINGS.birthdayInfoText);
                        this.newCustomer.dateOfBirth = userAge.date;
                    }
                }
                else {
                    this.addErrorToFormField(form_const_1.MAPPINGS.birthdayInfoText, form_const_1.CUSTOMERRORS.underMinimumAge);
                }
            }
            else {
                this.newCustomer.dateOfBirth = userAge.date;
                this.removeErrorFromFormField(form_const_1.MAPPINGS.birthdayInfoText);
            }
        }
        else {
            this.addErrorToFormField(form_const_1.MAPPINGS.birthdayInfoText);
        }
        [
            'firstname',
            'lastname',
            'zipCode',
            'city',
            'street',
            'houseNumber',
            'email',
            'referralCode',
        ].forEach(function (key) { return (_this.newCustomer[key] = _this.get$Val(form_const_1.MAPPINGS[key])); });
        if (localStorage.getItem('leaduuid')) {
            this.newCustomer.identityToken = localStorage.getItem('leaduuid');
        }
        //Set correct phone number
        var phonePrefix = localStorage.getItem('phonePrefix');
        var phone = localStorage.getItem(form_const_1.MAPPINGS.telephone_mobile.localStorageKey);
        this.newCustomer.telephone_mobile = phonePrefix + phone;
        var gender = this.get$Val(form_const_1.MAPPINGS.gender);
        if (gender === 'FEMALE' || gender === 'MALE' || gender === 'UNISEX') {
            this.newCustomer.gender = gender;
            this.removeErrorFromFormField(form_const_1.MAPPINGS.genderInput);
        }
        else {
            this.addErrorToFormField(form_const_1.MAPPINGS.genderInput);
        }
        if (!$(form_const_1.MAPPINGS.consent.id).is(':checked') && ((_f = form_const_1.MAPPINGS.consent) === null || _f === void 0 ? void 0 : _f.required)) {
            this.addErrorToFormField(form_const_1.MAPPINGS.consent);
        }
        else {
            this.removeErrorFromFormField(form_const_1.MAPPINGS.consent);
        }
        if (variables_const_1.environment === 'dev') {
            console.info('Contract', this.newContract);
            console.info('Customer', this.newCustomer);
            console.info('this', this);
        }
        this.paymentProvider();
        this.helper.scrollToFirstErrorField();
        return this.formInvalid;
    };
    Form.prototype.paymentProvider = function () {
        var _a;
        if (((_a = this.stripePayment) === null || _a === void 0 ? void 0 : _a.magiclinePaymentChoice) === 'STRIPE') {
            //fake data to satisfy Magicline if paid via
            this.newCustomer.bankAccount = payment_const_1._FakeIBAN;
        }
        else {
            this.newCustomer.bankAccount = {
                accountHolder: this.get$Val(form_const_1.MAPPINGS.accountHolder),
                iban: this.get$Val(form_const_1.MAPPINGS.iban).replace(/\_/gi, '').trim(),
            };
            var bic = $('#BIC').val();
            if (typeof bic === 'string' && bic.length && $('#BIC').length) {
                this.newCustomer.bankAccount.bic = this.helper
                    .get$Val(form_const_1.MAPPINGS.bic)
                    .replace(/\_/gi, '')
                    .trim();
            }
        }
    };
    Form.prototype.loadModule = function () {
        var _this = this;
        var _a;
        this.elementGenerator.createElements();
        if ((_a = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.stripe) === null || _a === void 0 ? void 0 : _a.stripeKey) {
            Promise.resolve().then(function () { return __importStar(require('./stripe-payment')); }).then(function (StripePaymentModule) {
                _this.stripePayment = object_service_1.ObjectService.getInstance(StripePaymentModule.StripePayment);
                _this.stripePayment.loadModule();
            });
        }
        if (variables_const_1.environment === 'dev') {
            console.log('Perform load module');
        }
        this.prepareForm();
        this.fillFormFromLocalStorage();
        if (!variables_const_1._legacyCode) {
            this.disableHiddenFields();
        }
        if (variables_const_1.environment === 'dev') {
            this.checkIfAllFieldsExist();
            this.helper.printLocalStorage();
        }
    };
    //this will only be executed on dev
    Form.prototype.checkIfAllFieldsExist = function () {
        var _a;
        for (var _i = 0, _b = Object.values(form_const_1.MAPPINGS); _i < _b.length; _i++) {
            var entry = _b[_i];
            if (((_a = $(entry.id)) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                console.info('Seems like some input fields are missing', entry);
            }
        }
    };
    Form.prototype.fillFormFromLocalStorage = function () {
        for (var _i = 0, _a = Object.values(form_const_1.MAPPINGS).filter(function (a) { var _a; return (_a = a.localStorageKey) === null || _a === void 0 ? void 0 : _a.length; }); _i < _a.length; _i++) {
            var entry = _a[_i];
            var data = localStorage.getItem(entry.localStorageKey);
            if (data === null || data === void 0 ? void 0 : data.length) {
                $(entry.id).val(data);
            }
        }
    };
    Form.prototype.prepareForm = function () {
        var _this = this;
        this.errorHandling.hideErrorMessage();
        this.errorHandling.hideSuccessMessage();
        $(window).scrollTop(0);
        if (!localStorage.getItem(form_const_1.MAPPINGS.location.localStorageKey) &&
            variables_const_1._legacyCode === false) {
            if (variables_const_1.environment === 'prod') {
                window.location.replace('/membership/checkout');
            }
            else {
                console.error('NOTICE: on production script you would be now redirected to checkout since the location is not set in localstorage');
            }
        }
        $(form_const_1.MAPPINGS.voucherCode.id).on('change', function () { return __awaiter(_this, void 0, void 0, function () {
            var formInvalid, validVoucher, note, successRow, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        formInvalid = this.getDataFromInputs();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        validVoucher = void 0;
                        if (!(formInvalid === false)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.apiWrapper.validateVoucher(this.generateCustomerBody())];
                    case 2:
                        validVoucher = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.apiWrapper.validateVoucher({
                            voucherCode: this.helper.get$Val(form_const_1.MAPPINGS.voucherCode),
                            studioId: +this.helper.getPersistedData(form_const_1.MAPPINGS.location),
                            contract: this.newContract,
                            customer: customer_preview_const_1.PreviewCustomer,
                        })];
                    case 4:
                        //IF customer didnt fill out fields we use example data to validate voucher
                        validVoucher = _b.sent();
                        _b.label = 5;
                    case 5:
                        if (variables_const_1.environment === 'dev') {
                            console.log('Voucher has been entered:', validVoucher);
                        }
                        if (validVoucher === null || validVoucher === void 0 ? void 0 : validVoucher.voucherSuccessMessage) {
                            this.removeErrorFromFormField(form_const_1.MAPPINGS.voucherCode);
                            note = ((_a = validVoucher === null || validVoucher === void 0 ? void 0 : validVoucher.voucherRemarks) === null || _a === void 0 ? void 0 : _a.length)
                                ? translation_1.default.t('note') + ': ' + (validVoucher === null || validVoucher === void 0 ? void 0 : validVoucher.voucherRemarks)
                                : '';
                            successRow = this.elementGenerator.getRow({
                                html: validVoucher.voucherSuccessMessage,
                            }, 'success');
                            this.priceOverview.appendPricingDetails(successRow);
                            this.errorHandling.showSuccessMessage(validVoucher.voucherSuccessMessage);
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _b.sent();
                        this.addErrorToFormField(form_const_1.MAPPINGS.voucherCode, translation_1.default.t(error_1.message));
                        this.errorHandling.hideSuccessMessage();
                        this.priceOverview.removePricingDetails();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); });
        [
            $(form_const_1.MAPPINGS.yearOfBirth.id),
            $(form_const_1.MAPPINGS.monthOfBirth.id),
            $(form_const_1.MAPPINGS.dayOfBirth.id),
        ].forEach(function (a) {
            return a.on('change', function () {
                //if user age is < minimum age and the gym allows that we show guardian input otherwise an error is shown
                var userAge = _this.determineBirthDate();
                _this.guardianValidation(userAge === null || userAge === void 0 ? void 0 : userAge.age);
            });
        });
        $(form_const_1.MAPPINGS.submitButton.id).on('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
            var formInvalid, customer, stripeRes, e_1, newCustomer, e_2, sendcloud, e_3, submitButton, err_1;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        formInvalid = this.getDataFromInputs();
                        if (!(formInvalid === false && this.createCustomerLoading === false)) return [3 /*break*/, 22];
                        this.createCustomerLoading = true;
                        this.helper.createLoadingScreen();
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 20, , 21]);
                        customer = this.generateCustomerBody();
                        if (!(((_a = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.stripe) === null || _a === void 0 ? void 0 : _a.stripeKey) &&
                            ((_c = (_b = this === null || this === void 0 ? void 0 : this.newCustomer) === null || _b === void 0 ? void 0 : _b.bankAccount) === null || _c === void 0 ? void 0 : _c.accountHolder) ===
                                (payment_const_1._FakeIBAN === null || payment_const_1._FakeIBAN === void 0 ? void 0 : payment_const_1._FakeIBAN.accountHolder))) return [3 /*break*/, 6];
                        _f.label = 2;
                    case 2:
                        _f.trys.push([2, 4, , 5]);
                        this.helper.createLoadingScreen();
                        return [4 /*yield*/, this.stripePayment.startPayment(event, __assign(__assign({}, this.generateCustomerBody()), { contract: this.newContract }))];
                    case 3:
                        stripeRes = _f.sent();
                        if (stripeRes === 'success') {
                        }
                        else {
                            throw stripeRes;
                        }
                        console.log('perform stripe request', stripeRes);
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _f.sent();
                        this.errorHandling.showErrorMessage(typeof e_1 === 'string'
                            ? e_1
                            : 'Something went wrong with your payment');
                        this.helper.deleteLoadingScreen();
                        return [2 /*return*/];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        if (!((variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.technologyType) !== 'none')) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.apiWrapper.createNewCustomer(customer)];
                    case 7:
                        newCustomer = _f.sent();
                        if (newCustomer === null || newCustomer === void 0 ? void 0 : newCustomer.error) {
                            this.errorHandling.showErrorMessage('' + typeof (newCustomer === null || newCustomer === void 0 ? void 0 : newCustomer.error) === 'string'
                                ? translation_1.default.t(newCustomer.error)
                                : 'Sorry but please try again later');
                            throw newCustomer.error;
                        }
                        _f.label = 8;
                    case 8:
                        if (!((_d = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.receiverMail) === null || _d === void 0 ? void 0 : _d.sendNewMemberEmail)) return [3 /*break*/, 12];
                        _f.label = 9;
                    case 9:
                        _f.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, this.sendEmailService.sendEmail(variables_const_1._settings.receiverMail.sendNewMemberEmail, customer, 'Vertragsabschluss')];
                    case 10:
                        _f.sent();
                        return [3 /*break*/, 12];
                    case 11:
                        e_2 = _f.sent();
                        return [3 /*break*/, 12];
                    case 12: return [4 /*yield*/, this.finishLeads()];
                    case 13:
                        _f.sent();
                        if (!$(form_const_1.MAPPINGS.webflowSubmitButton.id).length) return [3 /*break*/, 18];
                        if (!((_e = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.finish) === null || _e === void 0 ? void 0 : _e.sendcloud)) return [3 /*break*/, 17];
                        _f.label = 14;
                    case 14:
                        _f.trys.push([14, 16, , 17]);
                        sendcloud = object_service_1.ObjectService.getInstance(sendcloud_welcomebox_1.SendcloudWelcomebox);
                        return [4 /*yield*/, sendcloud.sendToCustomer(this.newCustomer)];
                    case 15:
                        _f.sent();
                        return [3 /*break*/, 17];
                    case 16:
                        e_3 = _f.sent();
                        console.error('some issue with sendcloud', e_3);
                        return [3 /*break*/, 17];
                    case 17:
                        submitButton = $(form_const_1.MAPPINGS.webflowSubmitButton.id);
                        console.error('Pressing redirect button', form_const_1.MAPPINGS.webflowSubmitButton.id, $(form_const_1.MAPPINGS.webflowSubmitButton.id), submitButton);
                        this.createCustomerLoading = false;
                        this.helper.deleteLoadingScreen();
                        localStorage.removeItem('leaduuid');
                        submitButton[0].click();
                        return [3 /*break*/, 19];
                    case 18:
                        console.error('Submit button id is not defined', form_const_1.MAPPINGS.webflowSubmitButton.id);
                        _f.label = 19;
                    case 19: return [3 /*break*/, 21];
                    case 20:
                        err_1 = _f.sent();
                        console.error(err_1);
                        this.createCustomerLoading = false;
                        this.helper.deleteLoadingScreen();
                        return [3 /*break*/, 21];
                    case 21: return [3 /*break*/, 23];
                    case 22:
                        this.createCustomerLoading = false;
                        this.helper.deleteLoadingScreen();
                        _f.label = 23;
                    case 23: return [2 /*return*/];
                }
            });
        }); });
    };
    Form.prototype.guardianValidation = function (age) {
        $(form_const_1.MAPPINGS.guardianWrapper.id).hide();
        if (age && age < variables_const_1._matured) {
            if (age >= variables_const_1._minimumAge) {
                $(form_const_1.MAPPINGS.guardianWrapper.id).show();
                this.removeErrorFromFormField(form_const_1.MAPPINGS.birthdayInfoText);
            }
            else {
                this.addErrorToFormField(form_const_1.MAPPINGS.birthdayInfoText, form_const_1.CUSTOMERRORS.underMinimumAge);
            }
        }
        else {
            this.removeErrorFromFormField(form_const_1.MAPPINGS.birthdayInfoText);
        }
    };
    Form.prototype.generateCustomerBody = function () {
        return {
            voucherCode: this.helper.get$Val(form_const_1.MAPPINGS.voucherCode),
            studioId: +this.helper.getPersistedData(form_const_1.MAPPINGS.location),
            contract: this.newContract,
            customer: this.newCustomer,
        };
    };
    Form.prototype.disableHiddenFields = function () {
        var hiddenFields = Object.values(form_const_1.MAPPINGS).filter(function (a) { return a.disabled; });
        hiddenFields.forEach(function (a) { return $(a.id).prop('disabled', true); });
    };
    Form.prototype.determineBirthDate = function () {
        var _a = [
            this.get$Val(form_const_1.MAPPINGS.yearOfBirth),
            this.get$Val(form_const_1.MAPPINGS.monthOfBirth),
            this.get$Val(form_const_1.MAPPINGS.dayOfBirth),
        ], year = _a[0], month = _a[1], day = _a[2];
        if ((year === null || year === void 0 ? void 0 : year.length) && (month === null || month === void 0 ? void 0 : month.length) && (day === null || day === void 0 ? void 0 : day.length)) {
            var selectedBirthDate = this.helper.getBirthdayDate("".concat(year, "/").concat(month, "/").concat(day));
            var userAge = Math.floor((new Date().getTime() - new Date(selectedBirthDate).getTime()) /
                3.15576e10);
            localStorage.setItem('age', String(userAge));
            localStorage.setItem('customer.age', String(userAge));
            localStorage.setItem('birthday', String(selectedBirthDate));
            localStorage.setItem('customer.dateOfBirth', String(selectedBirthDate));
            return { age: userAge, date: selectedBirthDate };
        }
        else {
            var userAge = +localStorage.getItem('age');
            var selectedBirthDate = localStorage.getItem('birthday');
            if (userAge && selectedBirthDate) {
                return { age: userAge, date: selectedBirthDate };
            }
        }
        return undefined;
    };
    //helper functions
    Form.prototype.get$Val = function (mappingObject) {
        var value = this.helper.get$Val(mappingObject);
        this.formInvalid = (value === null || value === void 0 ? void 0 : value.length) === 0 && value === '';
        return value;
    };
    Form.prototype.addErrorToFormField = function (formField, customError) {
        this.formInvalid = true;
        this.helper.addErrorToFormField(formField, customError);
    };
    Form.prototype.removeErrorFromFormField = function (formField) {
        this.helper.removeErrorFromFormField(formField);
    };
    Form.prototype.finishLeads = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_4, manyChatApi, leadResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.apiWrapper.finishLead()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_4 = _a.sent();
                        console.error('Error finishing lead - ignored (member > lead)', e_4);
                        return [3 /*break*/, 3];
                    case 3:
                        if (!localStorage.getItem('manychat-lead-id')) return [3 /*break*/, 5];
                        manyChatApi = object_service_1.ObjectService.getInstance(manychat_api_1.ManyChatApi);
                        return [4 /*yield*/, manyChatApi.finishLeadInManyChat({
                                id: localStorage.getItem('manychat-lead-id'),
                                tenantId: variables_const_1._settings.tenantKey,
                                contract: true,
                            })];
                    case 4:
                        leadResponse = _a.sent();
                        if ((leadResponse === null || leadResponse === void 0 ? void 0 : leadResponse.success) && (leadResponse === null || leadResponse === void 0 ? void 0 : leadResponse.id)) {
                            localStorage.removeItem('manychat-lead-id');
                        }
                        else if (leadResponse.error) {
                            // this.errorHandling.showErrorMessage(leadResponse.error);
                        }
                        console.error(leadResponse);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return Form;
}());
exports.Form = Form;
